import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { RegexService } from '../../shared/form-validation/regex.service';
import { ApiService } from '../../shared/services/apiService.service';
import { RootService } from '../../shared/services/root.service';
import { environment } from '../../../environments/environment';
import { secureStorage } from '../../shared/services/encryption/secureservice';
import { isPlatformBrowser } from '@angular/common';
import jwtEncode from 'jwt-encode';

@Component({
  selector: 'app-vas-dashboard',
  templateUrl: './vas-dashboard.component.html',
  styleUrls: ['./vas-dashboard.component.scss'],
})
export class VasDashboardComponent implements OnInit {
  selectedIdDocNo: any = '';
  profileFormGroup!: FormGroup;
  selectedAddDocNo: any = '';
  kycKarzaRes: any;
  userKYCDetails: any;
  isIdKYCDone: boolean = false;
  isAddKYCDone: boolean = false;
  kycAddr: any;
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription();
  productLoaded: boolean = false;
  selectedAddressProof: any = null;
  selectedIDProof: any = null;
  userData: any;
  kycAddOne: any;
  kycAddrTwo: any;
  page: any;
  stateList: any;
  districtList: any = [];
  isAllowToEdit: boolean = false;
  pancard: any;
  checkBoxcheked:boolean=false;
  addressProofList = [
    { name: 'Aadhar Card', value: 'aadhar_card' },
  ];
  idProofList = [
    { name: 'Pan Card', value: 'id_pancard' },
    // { name: "Voter ID Card", value: "id_voter_card" },
  ];
  private secretKey =
    'eyJhbGciOiJIUzM4NCJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTcxNTIzMjg5OSwiaWF0IjoxNzE1MjMyODk5fQ.VPOznC6gBQvzh5ZKJWD6Up0VfWp9M4ZBZrjdKYlMoixF_k-SdFzc78KpZAMmDgRN';

  constructor(
    private toastrService: ToastrService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private secureService: RootService,
    private fb: FormBuilder,
    private regexService: RegexService,
    private localStorage: secureStorage,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getUserDetails();
  }
  getUserDetails() {

      let res = this.secureService.isLoggedIn();
      if (res) {
        this.sub.add(
          this.apiService.getUserData().subscribe({
            next: (response: any) => {
              this.userData = response['data'];
              this.kycAddOne = this.userData?.address_one;
              this.kycAddrTwo = this.userData?.address_two;
              if (this.userData?.user_documents) {
                for (let i = 0; i < this.userData.user_documents?.length; i++) {
                  if (
                    this.userData.user_documents[i].document_description ==
                      'aadhar_card' ||
                    this.userData.user_documents[i].document_description ==
                      'adhar_card'
                  ) {
                    this.selectedAddressProof =
                      this.userData.user_documents[i].document_description;
                          if (isPlatformBrowser(this.platformId)) {
                    this.selectedAddDocNo = this.localStorage.decryptData(
                      this.userData.user_documents[i].doc_number
                    );
                  }
                    this.isAddKYCDone = this.userData.user_documents[i].e_kyc;
                  } else if (
                    this.userData.user_documents[i].document_description ==
                    'id_pancard'
                  ) {
                    this.selectedIDProof =
                      this.userData.user_documents[i].document_description;
                          if (isPlatformBrowser(this.platformId)) {
                    this.selectedIdDocNo = this.localStorage.decryptData(
                      this.userData.user_documents[i].doc_number
                    );
                  }
                    this.pancard = this.selectedIdDocNo.toUpperCase();
                    this.isIdKYCDone = this.userData.user_documents[i].e_kyc;
                  } else {
                  }
                }
              }
            },
            error: () => {},
          })
        );
      } else {
        this.toastrService.warning('Kindly Login');
        this.router.navigate(['/login/']);
      }
    
  }

  verifyVas() {
    if (
      this.pancard == null ||
      this.pancard == undefined ||
      this.pancard == ''
    ) {
      this.toastrService.warning('Please enter the pan no');
      return;
    }

    if (!this.userData?.mobile_number) {
      this.toastrService.warning('Please enter the mobile number');
      return;
    }
    if (this.isValidPanCardNo(this.pancard)) {
      this.vasCount(this.userData.mobile_number)
      const tokenPayload = {
        mobile_no: this.userData.mobile_number,
        pan_no: this.pancard,
      };
      const encryptedToken = jwtEncode(tokenPayload, this.secretKey);
      // const url = `https://CustomerInsight360-pre-prod.tatamotors.com/#/Home/${encryptedToken}`;
      const url = `https://customerinsight360.tatamotors.com/#/Home/?token=${encryptedToken}`;

      if (isPlatformBrowser(this.platformId)) {
        window.open(url, '_blank');
      }
    }
  }

  isValidPanCardNo(panCardNo) {
    let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
    if (panCardNo == null) {
      this.toastrService.warning('Pan No is empty');
      return;
    }

    if (regex.test(panCardNo) == true) {
      return true;
    } else {
      this.toastrService.warning('invalid Pan No');

      return false;
    }
  }
  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }
  onCheckboxChange(checked: boolean) {
    if (checked) {
      this.checkBoxcheked=true
    } else {
      this.checkBoxcheked=false
    }
  }
  vasCount(value){
let data ={
    "mobile_number": value
}
    this.apiService.get_amc_consent_view(data).subscribe((res)=>{
    })
  }
  gototerms(){
    this.router.navigate(['/vas-dashboard-t-n-c'])
  }
}
